import { render, staticRenderFns } from "./BannerUsefulFilesSection.vue?vue&type=template&id=2dbf63ec"
import script from "./BannerUsefulFilesSection.vue?vue&type=script&lang=ts"
export * from "./BannerUsefulFilesSection.vue?vue&type=script&lang=ts"
import style0 from "./BannerUsefulFilesSection.vue?vue&type=style&index=0&id=2dbf63ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports